import { toTrainSerie } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/utils";
import { FC } from "react";
import { DropsBadge, HStack, DropsTooltip } from "shared/components/Spor";
import { Text } from "shared/components/typography/TitleStyles";
import { useTheme } from "styled-components";

type TrainSerieDisplayProps = {
  trainIds: string[];
};

export const TrainSerieDisplay: FC<TrainSerieDisplayProps> = ({ trainIds }) => {
  const theme = useTheme();
  return (
    <HStack>
      <DropsTooltip hasArrow label={trainIds.join(", ")}>
        <DropsBadge
          semantics="info"
          borderWidth="1px"
          borderRadius="6px"
          borderColor={theme.colorOutlineMain}
          backgroundColor="transparent"
          paddingLeft="0px !important"
          paddingRight="6px !important"
        >
          <DropsBadge
            semantics="info"
            borderWidth="1px"
            borderRadius="6px"
            borderColor={theme.colorInfoOutline}
            marginY="-6px"
            p="3px 6px !important"
          >
            <Text bold style={{ whiteSpace: "nowrap" }}>
              {toTrainSerie(trainIds[0])}
            </Text>
          </DropsBadge>
          <Text bold style={{ whiteSpace: "nowrap" }}>
            {trainIds.length} tog
          </Text>
        </DropsBadge>
      </DropsTooltip>
    </HStack>
  );
};
